<div [ngClass]="class">
  <ng-template #parent></ng-template>
</div>